import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-registration.svg'


const _withScopeId = n => (_pushScopeId("data-v-4021c863"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "reset-box"
}
const _hoisted_3 = { class: "reset" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header-logo",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_5 = { class: "reset__title" }
const _hoisted_6 = {
  key: 0,
  class: "reset__text"
}
const _hoisted_7 = {
  key: 1,
  class: "reset-box"
}
const _hoisted_8 = { class: "reset" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header-logo",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_10 = { class: "reset__title" }
const _hoisted_11 = { class: "reset__text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createBlock(_component_el_container, {
        key: 0,
        direction: "vertical"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_header, null, {
            "top-left": _withCtx(() => [
              (_ctx.resetForm)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/login",
                    class: "back-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.resetForm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$localize('login.send.login.link')), 1)
                ]),
                _createVNode(_component_Form, {
                  as: "el-form",
                  class: "form-box",
                  "validation-schema": _ctx.schema,
                  onSubmit: _ctx.onSubmit
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_app_input, {
                      ref: "inputEmail",
                      name: "email",
                      "prop-error": _ctx.emailError,
                      label: _ctx.$localize('reset.password.email'),
                      placeholder: _ctx.$localize('reset.password.email.placeholder')
                    }, null, 8, ["prop-error", "label", "placeholder"]),
                    (_ctx.errors.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.errors), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_app_button, {
                      type: "primary",
                      "native-type": "submit",
                      class: "w-100 el-button-lg",
                      disabled: _ctx.dataLoading,
                      round: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$localize('login.by.email.btn')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["validation-schema", "onSubmit"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.resetForm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.$localize('login.by.email.success')), 1),
                  _createElementVNode("p", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_ctx.$localize('login.by.email.success1')), 1),
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.$localize('login.by.email.success2')), 1)
                  ]),
                  _createVNode(_component_app_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/login'))),
                    type: "primary",
                    class: "w-100 el-button-lg",
                    disabled: _ctx.dataLoading,
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('login.by.email.button')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}